import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Paper,
  Card,
  TextField,
  CircularProgress
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode, ImportTemplateCodeEnum, LanguageCode } from '../../../helpers/Constants';
import { CloudDownloadOutlined } from '@material-ui/icons';
import FileSaver from 'file-saver';
import Referentials from '../../../helpers/Referentials.json';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {
  GTSupplierMapping,
  GTSupplierMappingImportedDto,
  GTSupplierMappingImportRequestDto,
  GTSupplierMappingFilterRequestDto,
  GTSupplierMappingDuplicateRequestDto,
  ImportGTSupplierMappingAttachment
} from '../../../interfaces/Case';
import MaterialTable from 'material-table';
import { getLocalization, MaterialTableIcons } from '../../_shared/TableSettings';
import CloudUploadOutlined from '@material-ui/icons/CloudUploadOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import FileUploadRow from '../../_shared/FileUploadRow';
import NumberFormat from 'react-number-format';

interface IGTSupplierMappingComponentState {
  newGTSupplierMapping: GTSupplierMapping;
  gtSupplierMappingList: GTSupplierMapping[];
  isLoading: boolean;
  isExporting: boolean;
  page: number;
  pageSize: number;
  count: number;
  selectedCategories: IReferential[];
  selectedBrands: IReferential[];
  selectedQualities: IReferential[];
  cupiCodeFilter: string;
  gtCodeFilter: string;
  associatedCodeFilter: string;
  modelFilter: string;
  gearboxFilter: string;
  differentialFilter: string;
  isDialogOpen: boolean;
  newGTSupplierMappingId: number | null;
  categoryList: IReferential[];
  brandList: IReferential[];
  qualityList: IReferential[];
  isLoadingImportData: boolean;
  isDownloading: boolean;
  isImportDialogOpen: boolean;
  attachments: ImportGTSupplierMappingAttachment[];
  importedGTSupplierMappingList: GTSupplierMappingImportedDto[];
}
type IGTSupplierMappingComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class GTSupplierMappingComponent extends React.PureComponent<
  IGTSupplierMappingComponentProps,
  IGTSupplierMappingComponentState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;
  static contextType = ApplicationContext;
  private newGTSupplierMapping = {
    id: 0,
    categoryId: 0,
    brandId: 0,
    partQualityId: 0,
    cupiCode: null,
    gtCode: null,
    associatedCode: '',
    volumeLiters: null,
    price: null,
    modelDescription: null,
    gearboxCode: null,
    differentialCode: null
  } as GTSupplierMapping;

  state = {
    gtSupplierMappingList: [],
    isLoading: false,
    isExporting: false,
    page: 0,
    pageSize: 10,
    count: 0,
    selectedCategories: [] as IReferential[],
    selectedBrands: [] as IReferential[],
    selectedQualities: [] as IReferential[],
    cupiCodeFilter: '',
    gtCodeFilter: '',
    associatedCodeFilter: '',
    modelFilter: '',
    gearboxFilter: '',
    differentialFilter: '',
    isDialogOpen: false,
    newGTSupplierMapping: this.newGTSupplierMapping,
    newGTSupplierMappingId: null,
    categoryList: [] as IReferential[],
    brandList: [] as IReferential[],
    qualityList: [] as IReferential[],
    isImportDialogOpen: false,
    isLoadingImportData: false,
    isDownloading: false,
    attachments: [] as ImportGTSupplierMappingAttachment[],
    importedGTSupplierMappingList: [] as GTSupplierMappingImportedDto[]
  } as IGTSupplierMappingComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadData();
      }
    );
  }

  private buildFilter = (
    page: number,
    pageSize: number | null
  ): GTSupplierMappingFilterRequestDto => {
    return {
      categoryIds: this.state.selectedCategories.map((item) => item.id),
      brandIds: this.state.selectedBrands.map((item) => item.id),
      qualityIds: this.state.selectedQualities.map((item) => item.id),
      cupiCode: this.state.cupiCodeFilter || null,
      gtCode: this.state.gtCodeFilter || null,
      associatedCode: this.state.associatedCodeFilter || null,
      modelDescription: this.state.modelFilter || null,
      gearboxCode: this.state.gearboxFilter || null,
      differentialCode: this.state.differentialFilter || null,
      page: page + 1,
      pageSize: pageSize,
      language:
        this.props.appState.language == LanguageCode.RO ? LanguageCode.RO : LanguageCode.EN
    } as GTSupplierMappingFilterRequestDto;
  };

  loadData = async () => {
    const categoryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Category
    );
    const brandRef = Referentials.referential.find((item) => item.code === ReferentialCode.CarBrands);
    const qualityRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.CarPartCategory
    );

    const [categoryList, brandList, qualityList, response] = await Promise.all([
      this.appReferentialService.Get(categoryRef!.baseUrl),
      this.appReferentialService.Get(brandRef!.baseUrl),
      this.appReferentialService.Get(qualityRef!.baseUrl),
      this.caseService.GetGTSupplierMappingList(
        this.buildFilter(this.state.page, this.state.pageSize)
      )
    ]);

    this.setState({
      gtSupplierMappingList: response.gtSupplierMappings,
      count: response.total,
      page: response.page - 1,
      isLoading: false,
      newGTSupplierMapping: { ...this.newGTSupplierMapping },
      categoryList: categoryList,
      brandList: brandList,
      qualityList: qualityList
    });
  };

  reloadGTSupplierMappings = async (page: number, pageSize: number) => {
    this.setState({ isLoading: true });

    const response = await this.caseService.GetGTSupplierMappingList(
      this.buildFilter(page, pageSize)
    );

    this.setState({
      gtSupplierMappingList: response.gtSupplierMappings,
      count: response.total,
      page: response.page - 1,
      pageSize: pageSize,
      isLoading: false
    });
  };

  handleCategoriesChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedCategories: newValue, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleBrandsChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedBrands: newValue, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleQualitiesChange = (newValue: IReferential[]) => {
    this.setState(
      { selectedQualities: newValue, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleCupiCodeFilterChange = (value: string) => {
    this.setState(
      { cupiCodeFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleGtCodeFilterChange = (value: string) => {
    this.setState(
      { gtCodeFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleAssociatedCodeFilterChange = (value: string) => {
    this.setState(
      { associatedCodeFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleModelFilterChange = (value: string) => {
    this.setState(
      { modelFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleGearboxFilterChange = (value: string) => {
    this.setState(
      { gearboxFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleDifferentialFilterChange = (value: string) => {
    this.setState(
      { differentialFilter: value, isLoading: true, page: 0 },
      async () => await this.reloadGTSupplierMappings(0, this.state.pageSize)
    );
  };

  handleExport = async () => {
    this.setState({ isExporting: true });
    try {
      const blob = await this.caseService.GetGTSupplierMappingExport(
        this.buildFilter(this.state.page, null)
      );
      FileSaver.saveAs(
        blob,
        `${this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_EXPORT_FILE_NAME', 'Mapari GT furnizori')}.xlsx`
      );
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } finally {
      this.setState({ isExporting: false });
    }
  };

  renderFilters = () => {
    return (
      <div className="mt-3">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="categoryFilter"
                multiple
                options={this.state.categoryList}
                value={this.state.selectedCategories}
                onChange={(e: any, newValue: any) => this.handleCategoriesChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="categoryFilter"
                    label={this.translatorService.Tranlate(
                      'GT_SUPPLIER_MAPPING_CATEGORY_LABEL',
                      'Categorie'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="cupiCodeFilter"
                value={this.state.cupiCodeFilter}
                onChange={(e: any) => this.handleCupiCodeFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_CUPI_CODE_LABEL',
                  'Cupi Code'
                )}
                fullWidth
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="modelFilter"
                value={this.state.modelFilter}
                onChange={(e: any) => this.handleModelFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_MODEL_DESCRIPTION_LABEL',
                  'Descriere model'
                )}
                fullWidth
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="brandFilter"
                multiple
                options={this.state.brandList}
                value={this.state.selectedBrands}
                onChange={(e: any, newValue: any) => this.handleBrandsChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="brandFilter"
                    label={this.translatorService.Tranlate(
                      'GT_SUPPLIER_MAPPING_BRAND_LABEL',
                      'Marca'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="gtCodeFilter"
                value={this.state.gtCodeFilter}
                onChange={(e: any) => this.handleGtCodeFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_GT_CODE_LABEL',
                  'Cod GT'
                )}
                fullWidth
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="gearboxFilter"
                value={this.state.gearboxFilter}
                onChange={(e: any) => this.handleGearboxFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_GEARBOX_CODE_LABEL',
                  'Cod cutie'
                )}
                fullWidth
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box mb={2}>
              <Autocomplete
                id="qualityFilter"
                multiple
                options={this.state.qualityList}
                value={this.state.selectedQualities}
                onChange={(e: any, newValue: any) => this.handleQualitiesChange(newValue)}
                getOptionLabel={(option: IReferential) => option.displayName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="qualityFilter"
                    label={this.translatorService.Tranlate(
                      'GT_SUPPLIER_MAPPING_QUALITY_LABEL',
                      'Calitate'
                    )}
                    fullWidth
                  />
                )}
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="associatedCodeFilter"
                value={this.state.associatedCodeFilter}
                onChange={(e: any) => this.handleAssociatedCodeFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_ASSOCIATED_CODE_LABEL',
                  'Cod Asociat'
                )}
                fullWidth
              />
            </Box>
            <Box mb={2}>
              <TextField
                id="differentialFilter"
                value={this.state.differentialFilter}
                onChange={(e: any) => this.handleDifferentialFilterChange(e.target.value)}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_DIFFERENTIAL_CODE_LABEL',
                  'Tip diferential'
                )}
                fullWidth
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  private handleCategoryChange = (newValue: IReferential | null) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        category: newValue,
        categoryId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleBrandChange = (newValue: IReferential | null) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        brand: newValue,
        brandId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleQualityChange = (newValue: IReferential | null) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        partQuality: newValue,
        partQualityId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleModelDescriptionChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        modelDescription: value === '' ? null : value
      }
    });
  };

  private handleGearboxCodeChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        gearboxCode: value === '' ? null : value
      }
    });
  };

  private handleDifferentialCodeChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        differentialCode: value === '' ? null : value
      }
    });
  };

  private handleCupiCodeChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        cupiCode: value
      }
    });
  };

  private handleGtCodeChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        gtCode: value
      }
    });
  };

  private handleAssociatedCodeChange = (value: string) => {
    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        associatedCode: value
      }
    });
  };

  private handleVolumeLitersChange = (value: string) => {
    const num = value === '' || value === undefined ? null : parseFloat(value);

    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        volumeLiters: num !== null && !isNaN(num) ? num : null
      }
    });
  };

  private handlePriceChange = (value: string) => {
    const num = value === '' || value === undefined ? null : parseFloat(value);

    this.setState({
      newGTSupplierMapping: {
        ...this.state.newGTSupplierMapping,
        price: num !== null && !isNaN(num) ? num : null
      }
    });
  };

  private NumberFormatCustom = (numberProps: any) => {
    const { inputRef, onChange, ...other } = numberProps;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: { value: values.value },
            currentTarget: { value: values.value }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  public saveGTSupplierMapping = async () => {
    const newGTSupplierMapping = {
      ...this.state.newGTSupplierMapping,
      gearboxCode: this.state.newGTSupplierMapping.gearboxCode || null,
      differentialCode: this.state.newGTSupplierMapping.differentialCode || null
    };
    const duplicateResponse = await this.caseService.CheckGTSupplierMappingDuplicate({
      id: newGTSupplierMapping.id,
      categoryId: newGTSupplierMapping.categoryId,
      brandId: newGTSupplierMapping.brandId,
      cupiCode: newGTSupplierMapping.cupiCode,
      gtCode: newGTSupplierMapping.gtCode,
      partQualityId: newGTSupplierMapping.partQualityId,
      associatedCode: newGTSupplierMapping.associatedCode,
      modelDescription: newGTSupplierMapping.modelDescription,
      gearboxCode: newGTSupplierMapping.gearboxCode,
      differentialCode: newGTSupplierMapping.differentialCode
    } as GTSupplierMappingDuplicateRequestDto);

    if (duplicateResponse.isDuplicate) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_EXISTS',
          'Maparea introdusa exista deja in lista'
        ),
        { variant: 'error' }
      );
      return;
    }

    try {
      if (this.state.newGTSupplierMappingId === null) {
        await this.caseService.AddGTSupplierMapping(newGTSupplierMapping);
      } else {
        await this.caseService.UpdateGTSupplierMapping(newGTSupplierMapping);
      }
      await this.loadData();
      this.closeDialog();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveGTSupplierMapping} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="category"
            fullWidth
            options={this.state.categoryList}
            value={this.state.newGTSupplierMapping.category}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleCategoryChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="category"
                value={this.state.newGTSupplierMapping.category || ''}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_CATEGORY_LABEL',
                  'Categorie'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="brand"
            fullWidth
            options={this.state.brandList}
            value={this.state.newGTSupplierMapping.brand}
            onChange={(e: any, newValue: IReferential | null) => this.handleBrandChange(newValue)}
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="brand"
                value={this.state.newGTSupplierMapping.brand || ''}
                label={this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_BRAND_LABEL', 'Marca')}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="modelDescription"
            id="modelDescription"
            value={this.state.newGTSupplierMapping.modelDescription || ''}
            onChange={(e: any) => this.handleModelDescriptionChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_MODEL_DESCRIPTION_LABEL',
              'Descriere model'
            )}
            validators={[]}
            errorMessages={[]}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="gearboxCode"
            id="gearboxCode"
            value={this.state.newGTSupplierMapping.gearboxCode || ''}
            onChange={(e: any) => this.handleGearboxCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_GEARBOX_CODE_LABEL',
              'Cod cutie'
            )}
            validators={[]}
            errorMessages={[]}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="differentialCode"
            id="differentialCode"
            value={this.state.newGTSupplierMapping.differentialCode || ''}
            onChange={(e: any) => this.handleDifferentialCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_DIFFERENTIAL_CODE_LABEL',
              'Tip diferential'
            )}
            validators={[]}
            errorMessages={[]}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="cupiCode"
            id="cupiCode"
            value={this.state.newGTSupplierMapping.cupiCode || ''}
            onChange={(e: any) => this.handleCupiCodeChange(e.target.value)}
            label={this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_CUPI_CODE_LABEL', 'Cupi Code')}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="gtCode"
            id="gtCode"
            value={this.state.newGTSupplierMapping.gtCode || ''}
            onChange={(e: any) => this.handleGtCodeChange(e.target.value)}
            label={this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_GT_CODE_LABEL', 'Cod GT')}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="partQuality"
            fullWidth
            options={this.state.qualityList}
            value={this.state.newGTSupplierMapping.partQuality}
            onChange={(e: any, newValue: IReferential | null) => this.handleQualityChange(newValue)}
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="partQuality"
                value={this.state.newGTSupplierMapping.partQuality || ''}
                label={this.translatorService.Tranlate(
                  'GT_SUPPLIER_MAPPING_QUALITY_LABEL',
                  'Calitate'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="associatedCode"
            id="associatedCode"
            value={this.state.newGTSupplierMapping.associatedCode || ''}
            onChange={(e: any) => this.handleAssociatedCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_ASSOCIATED_CODE_LABEL',
              'Cod Asociat'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="volumeLiters"
            id="volumeLiters"
            value={this.state.newGTSupplierMapping.volumeLiters ?? ''}
            onChange={(e: any) => this.handleVolumeLitersChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_VOLUME_LITERS_LABEL',
              'Volum (litri)'
            )}
            validators={[]}
            errorMessages={[]}
            InputProps={{
              inputComponent: this.NumberFormatCustom,
              style: { fontWeight: 500 }
            }}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="price"
            id="price"
            value={this.state.newGTSupplierMapping.price ?? ''}
            onChange={(e: any) => this.handlePriceChange(e.target.value)}
            label={this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_PRICE_LABEL', 'Pret')}
            validators={['required', 'minNumber:0']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu'),
              this.translatorService.Tranlate('VALIDATORS_MIN_VALUE', 'Valoare minima 0')
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom,
              style: { fontWeight: 500 }
            }}
          />
        </Box>

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'category',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_CATEGORY_LABEL', 'Categorie'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => a.name!.localeCompare(b.name!),
          customBodyRender: (value: IReferential) => (value ? value.displayName : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'brand',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_BRAND_LABEL', 'Marca'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => a.name!.localeCompare(b.name!),
          customBodyRender: (value: IReferential) => (value ? value.displayName : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'modelDescription',
        label: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_MODEL_DESCRIPTION_LABEL',
          'Descriere model'
        ),
        options: {
          customBodyRender: (value: string | null) => value || ''
        } as MUIDataTableColumnOptions
      },
      {
        name: 'gearboxCode',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_GEARBOX_CODE_LABEL', 'Cod cutie'),
        options: {
          customBodyRender: (value: string | null) => value || ''
        } as MUIDataTableColumnOptions
      },
      {
        name: 'differentialCode',
        label: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_DIFFERENTIAL_CODE_LABEL',
          'Tip diferential'
        ),
        options: {
          customBodyRender: (value: string | null) => value || ''
        } as MUIDataTableColumnOptions
      },
      {
        name: 'cupiCode',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_CUPI_CODE_LABEL', 'Cupi Code')
      },
      {
        name: 'gtCode',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_GT_CODE_LABEL', 'Cod GT')
      },
      {
        name: 'partQuality',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_QUALITY_LABEL', 'Calitate'),
        options: {
          customBodyRender: (value: IReferential) => (value ? value.displayName : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'associatedCode',
        label: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_ASSOCIATED_CODE_LABEL',
          'Cod Asociat'
        )
      },
      {
        name: 'volumeLiters',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_VOLUME_LITERS_LABEL', 'Volum (litri)'),
        options: {
          customBodyRender: (value: number | null) => (value != null ? String(value) : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'price',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_PRICE_LABEL', 'Pret'),
        options: {
          customBodyRender: (value: number | null) => (value != null ? String(value) : '')
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        label: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_ACTIONS_LABEL', 'Actiuni'),
        options: {
          viewColumns: false,
          filter: false,
          sort: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newGTSupplierMappingPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteGTSupplierMapping(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteGTSupplierMapping = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.caseService.RemoveGTSupplierMapping(id);
      await this.loadData();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newGTSupplierMappingPopup = async (gtSupplierMappingId: number | null) => {
    let newGTSupplierMapping: GTSupplierMapping;
    if (gtSupplierMappingId == null) {
      newGTSupplierMapping = { ...this.state.newGTSupplierMapping } as GTSupplierMapping;
    } else {
      newGTSupplierMapping = this.state.gtSupplierMappingList.find(
        (item) => item.id === gtSupplierMappingId
      )!;
    }
    this.setState({
      isDialogOpen: true,
      newGTSupplierMapping: newGTSupplierMapping,
      newGTSupplierMappingId: gtSupplierMappingId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newGTSupplierMapping: this.newGTSupplierMapping
    });
  };

  openImportDialog = async () => {
    this.setState({
      isImportDialogOpen: true,
      isLoadingImportData: false,
      attachments: [],
      importedGTSupplierMappingList: []
    });
  };

  closeImportDialog = async () => {
    this.setState(
      {
        isImportDialogOpen: false,
        isLoading: true,
        importedGTSupplierMappingList: [],
        attachments: []
      },
      async () => {
        await this.loadData();
      }
    );
  };

  handleDeleteAttachment = (id: number) => {
    const attachments = this.state.attachments.filter((a) => a.id !== id);
    this.setState({ attachments });
  };

  handleUploadFileSelected = (file: File) => {
    const attachments = [...this.state.attachments];
    attachments.push({
      id: 0,
      file,
      fileName: file.name,
      uploadDate: new Date(),
      originalFileName: file.name
    });
    this.setState({ attachments });
  };

  handleUploadFileRemoved = () => {
    const attachment = this.state.attachments[0];
    if (attachment) {
      this.handleDeleteAttachment(attachment.id);
    }
  };

  handleDownloadModel = async () => {
    if (this.state.isDownloading) {
      return;
    }
    this.setState({ isDownloading: true });
    try {
      const blob = await this.caseService.GetImportModel(
        ImportTemplateCodeEnum.GT_SUPPLIER_MAPPING_IMPORT_TEMPLATE
      );
      FileSaver.saveAs(blob, 'Mapari GT furnizori.xlsx');
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    } finally {
      this.setState({ isDownloading: false });
    }
  };

  renderInfoRow = (
    iconNode: React.ReactNode,
    iconBgColor: string,
    title: string,
    description: React.ReactNode,
    actionNode: React.ReactNode
  ) => (
    <Paper
      variant="outlined"
      className="p-3 mb-3 d-flex flex-row align-items-center"
      style={{ borderRadius: 8 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          width: 44,
          height: 44,
          borderRadius: 6,
          backgroundColor: iconBgColor,
          marginRight: 16
        }}
      >
        {iconNode}
      </Box>
      <Box flexGrow={1}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>
      {actionNode}
    </Paper>
  );

  renderAttachmentBox = () => {
    const attachment = this.state.attachments[0];

    return (
      <Box className="mt-2 mb-4">
        {this.renderInfoRow(
          <DescriptionOutlinedIcon style={{ color: '#FF7345' }} />,
          '#FFF5F2',
          this.translatorService.Tranlate(
            'GT_SUPPLIER_MAPPING_IMPORT_ALLOWED_FORMAT',
            'Format fisier acceptat: .XLSX'
          ),
          this.translatorService.Tranlate(
            'GT_SUPPLIER_MAPPING_IMPORT_ALLOWED_FORMAT_DESC',
            'Descarca modelul si pastreaza structura asteptata inainte de a importa maparile GT furnizori.'
          ),
          <Button
            variant="contained"
            onClick={this.handleDownloadModel}
            disabled={this.state.isDownloading}
            color="secondary"
            startIcon={<GetAppOutlinedIcon />}
            style={{
              textTransform: 'none',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            {this.translatorService.Tranlate(
              'GT_SUPPLIER_MAPPING_DOWNLOAD_MODEL_BTN',
              'Descarca model'
            )}
          </Button>
        )}

        <FileUploadRow
          inputId="gt-supplier-mapping-import-file"
          title={this.translatorService.Tranlate(
            'GT_SUPPLIER_MAPPING_IMPORT_ADD_FILE',
            'Adauga fisier mapari GT furnizori'
          )}
          emptyDescription={this.translatorService.Tranlate(
            'GT_SUPPLIER_MAPPING_IMPORT_ADD_FILE_DESC',
            'Selecteaza un fisier .xlsx'
          )}
          uploadButtonLabel={this.translatorService.Tranlate(
            'GT_SUPPLIER_MAPPING_IMPORT_UPLOAD_FILE',
            'Incarca fisier'
          )}
          accept=".xls,.xlsx"
          fileName={attachment?.originalFileName ?? null}
          onFileSelected={this.handleUploadFileSelected}
          onFileRemoved={this.handleUploadFileRemoved}
        />
      </Box>
    );
  };

  handleImport = async () => {
    if (this.state.attachments.length === 0) {
      this.props.enqueueSnackbar(
        this.translatorService.Tranlate(
          'ERROR_MSG_FILE_NOT_SELECTED',
          'Va rugam sa selectati un fisier!'
        ),
        {
          variant: 'error'
        }
      );
      return;
    }
    this.setState({ isLoadingImportData: true });

    const request = {
      attachments: this.state.attachments
    } as GTSupplierMappingImportRequestDto;

    try {
      const result = await this.caseService.SaveImportedGTSupplierMapping(request);
      this.props.enqueueSnackbar(
        <div>
          <p>
            {this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_DATA_PROCESSED', 'Date tratate: ')}{' '}
            {result.totalNumber}
          </p>
          <p>
            {this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_TREATED_SUCCESSFULLY', 'Tratate cu succes: ')}{' '}
            {result.importedNumber}
          </p>
        </div>,
        { variant: 'info', autoHideDuration: 6000 }
      );
      this.setState({
        importedGTSupplierMappingList: result.gtSupplierMappingList,
        isLoadingImportData: false
      });
    } catch {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error',
        autoHideDuration: 6000
      });
      this.setState({ isLoadingImportData: false });
    }
  };

  getImportedColumns = () => {
    return [
      {
        field: 'category',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_CATEGORY_LABEL', 'Categorie')
      },
      {
        field: 'brand',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_BRAND_LABEL', 'Marca')
      },
      {
        field: 'modelDescription',
        title: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_MODEL_DESCRIPTION_LABEL',
          'Descriere model'
        )
      },
      {
        field: 'gearboxCode',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_GEARBOX_CODE_LABEL', 'Cod cutie')
      },
      {
        field: 'differentialCode',
        title: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_DIFFERENTIAL_CODE_LABEL',
          'Tip diferential'
        )
      },
      {
        field: 'cupiCode',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_CUPI_CODE_LABEL', 'Cupi Code')
      },
      {
        field: 'gtCode',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_GT_CODE_LABEL', 'Cod GT')
      },
      {
        field: 'partQuality',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_QUALITY_LABEL', 'Calitate')
      },
      {
        field: 'associatedCode',
        title: this.translatorService.Tranlate(
          'GT_SUPPLIER_MAPPING_ASSOCIATED_CODE_LABEL',
          'Cod Asociat'
        )
      },
      {
        field: 'volumeLiters',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_VOLUME_LITERS_LABEL', 'Volum (litri)'),
        render: (rowData: GTSupplierMappingImportedDto) =>
          rowData.volumeLiters != null ? String(rowData.volumeLiters) : ''
      },
      {
        field: 'price',
        title: this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_PRICE_LABEL', 'Pret'),
        render: (rowData: GTSupplierMappingImportedDto) =>
          rowData.price != null ? String(rowData.price) : ''
      },
      {
        field: 'importMessage',
        title: this.translatorService.Tranlate('MAVO_VEHICLES_VEHICLE_IMPORT_MESSAGE', 'Rezultat import')
      }
    ];
  };

  renderImportedResultBox = () => {
    return this.state.importedGTSupplierMappingList.length > 0 ? (
      <MaterialTable
        columns={this.getImportedColumns()}
        data={this.state.importedGTSupplierMappingList}
        title=""
        icons={MaterialTableIcons}
        localization={getLocalization(this.translatorService)}
        options={{
          actionsColumnIndex: -1,
          addRowPosition: 'first',
          maxBodyHeight: 400,
          paging: false,
          sorting: false,
          search: false
        }}
        components={{
          Container: (props) => <Paper {...props} elevation={0} />
        }}
      />
    ) : (
      ''
    );
  };

  public renderImportContent() {
    return (
      <ValidatorForm onSubmit={this.handleImport} instantValidate={true}>
        {this.renderAttachmentBox()}
        <div className="d-flex flex-row text-center flex-wrap justify-content-center">
          <ScaleLoader color={'var(--primary)'} loading={this.state.isLoadingImportData} />
        </div>
        {this.renderImportedResultBox()}
        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeImportDialog}>
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_CLOSE_BTN', 'Renunta')}
          </Button>
          <Button
            className="m-2"
            variant="contained"
            color="secondary"
            type="submit"
            disabled={this.state.isLoadingImportData}
          >
            {this.translatorService.Tranlate('MAVO_VEHICLE_IMPORT_BTN', 'Importa')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    const options = {
      filter: false,
      search: false,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      viewColumns: false,
      elevation: 0,
      serverSide: true,
      count: this.state.count,
      rowsPerPage: this.state.pageSize,
      page: this.state.page,
      onTableChange: async (action: any, tableState: any) => {
        switch (action) {
          case 'changePage':
            await this.reloadGTSupplierMappings(tableState.page, tableState.rowsPerPage);
            break;
          case 'changeRowsPerPage':
            await this.reloadGTSupplierMappings(tableState.page, tableState.rowsPerPage);
            break;
          default:
        }
      },
      customToolbar: () => {
        return (
          <div>
            <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
              <IconButton
                aria-label="add"
                color="secondary"
                className="m-2"
                onClick={(e) => this.newGTSupplierMappingPopup(null)}
              >
                <AddCircleTwoToneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={this.translatorService.Tranlate('Import', 'Importa')}>
              <IconButton
                aria-label="import"
                color="primary"
                className="m-2"
                onClick={(e) => this.openImportDialog()}
              >
                <CloudUploadOutlined />
              </IconButton>
            </Tooltip>
            {this.state.isExporting ? (
              <CircularProgress
                size={20}
                color="primary"
                style={{ verticalAlign: 'middle', marginRight: 4 }}
              />
            ) : null}
            <Tooltip title={this.translatorService.Tranlate('Export', 'Exporta')}>
              <span>
                <IconButton
                  aria-label="export"
                  color="primary"
                  className="m-2"
                  disabled={this.state.isExporting}
                  onClick={(e) => this.handleExport()}
                >
                  <CloudDownloadOutlined />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        );
      }
    };

    return (
      <Fragment>
        <Card>
          <div
            style={{
              backgroundColor: 'var(--primary)',
              fontWeight: 500,
              borderBottom: '4px solid var(--primary-light)'
            }}
            className="card-header text-white text-center"
          >
            <span className="mb-0 py-2">
              {this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_TITLE', 'Mapari GT furnizori')}
            </span>
          </div>
          <div className="ml-3 mr-3">{this.renderFilters()}</div>
          <Box m={1} p={1}>
            <div className="d-flex flex-row text-center flex-wrap justify-content-center">
              <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
            </div>
            {!this.state.isLoading ? (
              <MUIDataTable
                title={''}
                data={this.state.gtSupplierMappingList}
                columns={this.getColumns()}
                options={options}
              />
            ) : null}
          </Box>
        </Card>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {!this.state.newGTSupplierMappingId
                      ? this.translatorService.Tranlate(
                          'GT_SUPPLIER_MAPPING_ADD_MODAL_TITLE',
                          'Adauga Mapare GT'
                        )
                      : this.translatorService.Tranlate(
                          'GT_SUPPLIER_MAPPING_UPDATE_MODAL_TITLE',
                          'Actualizeaza Mapare GT'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
        {this.state.isImportDialogOpen ? (
          <Dialog
            onClose={this.closeImportDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isImportDialogOpen}
            fullScreen={true}
            fullWidth={true}
          >
            <DialogTitle
              id="customized-dialog-title"
              style={{
                color: '#ffffff',
                backgroundColor: 'var(--primary)',
                textAlign: 'center'
              }}
            >
              <span style={{ fontSize: '20px', lineHeight: '24px' }}>
                {this.translatorService.Tranlate('GT_SUPPLIER_MAPPING_IMPORT_MODAL_TITLE', 'Importa date ')}
              </span>
              <IconButton
                aria-label="close"
                className="position-absolute"
                style={{ right: 12, top: 12, color: '#ffffff' }}
                onClick={this.closeImportDialog}
                size={'small'}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box m={1} p={1}>
                {this.renderImportContent()}
              </Box>
            </DialogContent>
          </Dialog>
        ) : (
          ''
        )}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(GTSupplierMappingComponent as any));
